export default __webpack_public_path__ + "static/media/eventsClose.3d744ce6.svg";